import React from 'react';

// Simple VirtualList component - renders all items (not truly virtualized)
// For large lists, consider react-window or react-virtuoso
export const VirtualList = ({ items, renderItem, height = 400, itemHeight = 50, className = '' }) => {
  return (
    <div className={`overflow-auto ${className}`} style={{ height }}>
      {items.map((item, index) => (
        <div key={item.id || index} style={{ minHeight: itemHeight }}>
          {renderItem(item, index)}
        </div>
      ))}
    </div>
  );
};

// Simple VirtualGrid component
export const VirtualGrid = ({ items, renderItem, columns = 3, height = 400, className = '' }) => {
  return (
    <div className={`overflow-auto ${className}`} style={{ height }}>
      <div className={`grid gap-4`} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {items.map((item, index) => (
          <div key={item.id || index}>
            {renderItem(item, index)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VirtualList;
